import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

@Component({
  selector: 'app-ui-form',
  templateUrl: './ui-form.component.html',
  styleUrls: ['./ui-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFormComponent implements OnChanges {
  @Input() form = new FormGroup({});
  @Input() field: FormlyFieldConfig[] = [];
  @Input() model: any;
  @Input() options: FormlyFormOptions = {};
  @Input() values: any;

  ngOnChanges() {
    this.form.patchValue(this.values);
  }
}
